<template>

    <GestionePreventiviPratiche />
  
  </template>
  
  <script>
  import GestionePreventiviPratiche from '../components/pratiche/gestione-pratiche/GestionePreventiviPratiche.vue'
  
  export default {
    components: {
      GestionePreventiviPratiche
  
    },
    data() {
      return {
  
      }
    },
  
    created(){
      
    },
  
    mounted(){
      this.$eventBus.emit('page-change', {
        target: this,
        currentRoute: this.$router.currentRoute.value
      })
    },
  
    methods: {
      
    },
  }
  </script>
  